import type { SystemStyleObject } from '@chakra-ui/react'
import { Flex, Link } from '@chakra-ui/react'
import { Email } from '../../icons'
import { Ellipsis } from 'brokertslib/src/components'

export const EmailAddress = ({ email, showIcon = true, sx }: { email: string, showIcon?: boolean, sx?: SystemStyleObject }) => {
  return showIcon ? (
    <Flex sx={{ gap: 2, flexWrap: 'wrap', ...sx }}>
      <Email color="secondary.500" />
      <Link href={`mailto:${email}`}><Ellipsis sx={sx}>{email}</Ellipsis></Link>
    </Flex>
  )
    :
    (
      <Link href={`mailto:${email}`}><Ellipsis sx={sx}>{email}</Ellipsis></Link>
    )
}